import { render, staticRenderFns } from "./QaForm.vue?vue&type=template&id=05f51384&scoped=true"
import script from "./QaForm.vue?vue&type=script&lang=js"
export * from "./QaForm.vue?vue&type=script&lang=js"
import style0 from "./QaForm.vue?vue&type=style&index=0&id=05f51384&prod&lang=less"
import style1 from "./QaForm.vue?vue&type=style&index=1&id=05f51384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_prettier@2.8.8_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f51384",
  null
  
)

export default component.exports